module.exports = __webpack_public_path__ + "static/img/man.333fa0c.svg";